module.exports = __webpack_public_path__ + "img/protekt-logo-slim-BW-transparent.9f9e7a38.png";